import {TranslateService} from '@ngx-translate/core';

export class ValidatorResult {
  constructor(public errorLabel: string, public errorLabelParam?: any) {
  }

  public getValidatorResultLabel(translate: TranslateService) {
    if (this.errorLabelParam) {
      return translate.instant(this.errorLabel, this.errorLabelParam);
    }
    return translate.instant(this.errorLabel);
  }
}

